import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers} from 'recompose';
import { reduxForm, arrayPush, arrayRemove, getFormValues } from 'redux-form'
import { clearCustomer, fetchCustomer, newCustomer, persistCustomer, deleteCustomer } from '../store/actions/customers';
import { fetchServers} from '../store/actions/servers';
import { fetchLocations} from '../store/actions/locations';
import { fetchOrganizations} from '../store/actions/organizations';
import { fetchCountries} from '../store/actions/countries';
import CustomerForm from '../components/customerForm/CustomerForm';
import { withLoadingComponent, withErrorComponent } from '../components/loading';
import { authRedirect } from '../lib/utils';
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, ownProps) => {
    const branches = (state.customer.customer?state.customer.customer.branches:[]);
    const locations = (state.customer.customer?state.customer.customer.locations:[]);
    const organizations = (state.customer.customer?state.customer.customer.organizations:[]);
    return {
        ...state.customer,
        formData: getFormValues("customerForm")(state),
        servers: state.servers.servers,
        tree: state.locations.locations,
        countries: state.countries.countries,
        branches,
        locations,
        organizations,
        initialValues: {
            ...state.customer.customer,
            branches: branches,
            locations: locations,
            organizations: organizations
        }
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const customerId = ownProps.match.params.customerId;

    return {
        fetchCustomer: () => {
            if('new' === customerId) {
                dispatch(newCustomer())
            } else {
                dispatch(fetchCustomer(customerId)).catch(authRedirect(ownProps))
            }
        },
        clearCustomer: () => {
            dispatch(clearCustomer())
        },
        fetchServers: () => {
            dispatch(fetchServers())
        },
        fetchLocations: (serverId) => {
            dispatch(fetchLocations(serverId))
        },
        fetchOrganizations: () => {
            dispatch(fetchOrganizations())
        },
        fetchCountries: () => {
            dispatch(fetchCountries("ROLE_CUSTOMER"))
        },
        deleteCustomer: () => {
            dispatch(deleteCustomer(customerId)).then(r => {
                ownProps.history.push(`/customers`)
            })
        },
        onCountryChanged: (event, index, value) => {
            dispatch(fetchServers(index));
        },
        loadServers: () => {
            dispatch(fetchServers());
        },
        onSubmit: (data) => {
            dispatch(persistCustomer(data)).then(r => {
                ownProps.history.push(`/customers`)
            })
        },
        addLink: (location) => {
            dispatch(arrayPush('customerForm', "locations", location))
        },
        removeLink: (index) => {
            dispatch(arrayRemove('customerForm', "locations", index))
        },
        addLinkOrg: (organization) => {
            console.log(organization);
            dispatch(arrayPush('customerForm', "organizations", {id: organization}))
        },
        removeLinkOrg: (index) => {
            dispatch(arrayRemove('customerForm', "organizations", index))
        }
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchCustomer();
        this.props.fetchServers();
        this.props.fetchCountries("ROLE_CUSTOMER");
    },
    componentWillUnmount() {
        this.props.clearCustomer()
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent,
    reduxForm({form: 'customerForm'}),
    withHandlers({
        onBackClick: props => () =>{alert("Back")}
    })
)(CustomerForm);


// WEBPACK FOOTER //
// ./src/containers/CustomerContainer.js